import { render, staticRenderFns } from "./BoundaryTreeTable.vue?vue&type=template&id=42dcc480&scoped=true"
import script from "./BoundaryTreeTable.vue?vue&type=script&lang=js"
export * from "./BoundaryTreeTable.vue?vue&type=script&lang=js"
import style0 from "./BoundaryTreeTable.vue?vue&type=style&index=0&id=42dcc480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dcc480",
  null
  
)

export default component.exports